// extracted by mini-css-extract-plugin
export default {"lock":"sYpAIU"};